<script>
import caseJs from './case.js'
import ButlerHttp from "../../common/ButlerHttp";

export default {
  name: 'case_file_form',
  props: {
    caseItem: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      requiredFileKeys: ['complaint_letter', 'evidence_list', 'owner_identity', 'reminder_letter'],
      fileTypes: [
        {
          type: 1,
          name: '起诉材料',
          files: {
            complaint_letter: '起诉状',
            evidence_list: '证据清单（电子章）',
            owner_identity: '业主身份信息',
            // property_certificate: '房产证 / 不动产登记查询结果',
            // service_contract: '物业服务合同 / 前期物业服务合同',
            // pre_service_contract: '前期物业服务合同',
            reminder_letter: '催件函',
            // other_letter : '其他资料（电子章）'
          }
        },
        // {
        //   type: 2,
        //   name: '公司主体资格证明',
        //   files: {
        //     business_license: '营业执照副本复印件（现章）',
        //     legal_representative_id: '法定代表人身份证明书（现章）',
        //     legal_representative_card: '法定代表人身份证复印件（现章）',
        //     // service_qualification: '物业服务资质证明',
        //     // charge_record: '收费备案 / 公示文件',
        //     authorization_letter: '授权委托书（现章）'
        //   }
        // },
        // {
        //   type: 3,
        //   name: '员工代理所需材料',
        //   files: {
        //     employee_id: '员工身份证复印件',
        //     labor_contract: '劳动合同',
        //     social_insurance: '社保证明'
        //   }
        // }
      ],
      fileList: [],
      loading: false,
      uploadQueue: [],  // 待上传文件队列
      uploadFileKeys: {},  // 跟踪每个 file_key 对应的上传状态
      checkFileKeys: {}  // 跟踪每个 file_key 的确认状态
    }
  },
  computed: {
    caseId() {
      return this.caseItem.id || this.caseItem.case_id || '';
    },
    houseId() {
      return this.caseItem.house_id || this.caseItem.HouseID || '';
    },
    fileKeyToTypeMap() {
      let map = {};
      this.fileTypes.forEach(type => {
        Object.keys(type.files).forEach(key => {
          map[key] = type.type;
        });
      });
      return map;
    }
  },
  mounted() {
    if (this.caseId) {
      this.getFileList();
    }
  },
  watch: {
    caseId: {
      handler(newVal) {
        if (newVal) {
          this.getFileList();
        }
      }
    }
  },
  methods: {
    getFileList() {
      if (!this.caseId) return;
      ButlerHttp.get('LawCaseFiles/getFileList', { case_id: this.caseId }, res => {
        if (res.code) {
          this.fileList = res.data || [];
        }
      });
    },
    handleUploadFile(params, file_key) {
      let file_name = params.file.name;
      let file_type = this.fileKeyToTypeMap[file_key] || 1;

      if (!this.uploadFileKeys[file_key]) {
        this.uploadFileKeys[file_key] = true;
        this.loading = true;

        caseJs.uploadFile(params.file, (res) => {
          if (res && res.hasOwnProperty('path')) {
            let file_data = {
              file_name: file_name,
              file_key: file_key,
              file_url: res.path,
              file_type: file_type,
              case_id: this.caseId,
              house_id: this.houseId
            };

            ButlerHttp.post('LawCaseFiles/saveFile', { file_list: [file_data] }, saveRes => {
              this.uploadFileKeys[file_key] = false;
              this.loading = false;
              if (saveRes.code) {
                this.getFileList();
                this.$message.success('上传成功');
              } else {
                this.$message.error(saveRes.msg || '保存失败');
              }
            });
          } else {
            this.uploadFileKeys[file_key] = false;
            this.loading = false;
            this.$message.error('上传失败');
          }
        });
      }
    },
    getFileListByKey(file_key) {
      if (!this.fileList) {
        return [];
      }
      return this.fileList.filter(f => f.file_key === file_key);
    },
    downloadFile(file) {
      if (file.file_url) {
        let open_url = caseJs.getFileUrl(file.file_url)
      window.open(open_url)
      }
    },
    deleteFile(file) {
      this.$confirm('确定要删除该文件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ButlerHttp.post('LawCaseFiles/deleteFile', { id: file.id }, res => {
          if (res.code) {
            this.$message.success('删除成功');
            this.getFileList();
          } else {
            this.$message.error(res.msg || '删除失败');
          }
        });
      }).catch(() => {
        // 用户取消删除
      });
    },
    isRequired(fileKey) {
      const keys = this.requiredFileKeys || [];
      return keys.indexOf(fileKey) !== -1;
    },
    handleCheckFile(fileKey) {
      const fileList = this.getFileListByKey(fileKey);
      const file = fileList.length > 0 ? fileList[0] : null;
      const newIsCheck = file && file.is_check ? 0 : 1;
      this.checkFileKeys[fileKey] = true;
      ButlerHttp.post('LawCaseFiles/checkFile', {
        house_id: this.houseId,
        file_key: fileKey,
        is_check: newIsCheck
      }, res => {
        this.checkFileKeys[fileKey] = false;
        if (res.code) {
          this.$message.success(newIsCheck ? '已确认' : '已取消确认');
          this.getFileList();
        } else {
          this.$message.error(res.msg || '操作失败');
        }
      });
    },
    goToSealFlow() {
      window.open('https://crm.gdzawy.com:9000/#/flow/FlowView?sheet_id=358&master_id=295&timeValue=' + caseJs.getTimestamp(), '_blank');
    }
  }
}
</script>

<template>
  <div>
    <el-table :data="fileTypes" border style="width: 100%">
      <el-table-column prop="name" label="材料类型" width="180"></el-table-column>
      <el-table-column label="上传材料">
        <template slot-scope="scope">
          <el-table :data="Object.entries(scope.row.files)" border size="mini">
            <el-table-column prop="[1]" width="200">
              <template slot="header">
                <span>材料名称</span>
              </template>
              <template slot-scope="props">
                <span v-if="requiredFileKeys.indexOf(props.row[0]) !== -1" style="color: #f56c6c; margin-left: 2px;">*</span>
                <span>{{ props.row[1] }}</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="80">
              <template slot-scope="props">
                <el-tag :type="getFileListByKey(props.row[0]).length > 0 ? 'success' : 'danger'" size="small">
                  {{ getFileListByKey(props.row[0]).length > 0 ? '已完善' : '未上传' }}
                </el-tag>

              </template>
            </el-table-column>
            <el-table-column label="已上传文件">
              <template slot-scope="props">
                <div style="display: flex; flex-wrap: wrap; gap: 8px;min-width:180px;">
                  <div v-for="(file, index) in getFileListByKey(props.row[0])" :key="index" style="display: flex; align-items: center;">
                    <el-tag
                      size="small" v-if="file.file_url"
                      style="cursor: pointer;"
                      @click="downloadFile(file)"
                    >
                      {{ file.file_name }}
                      <i class="el-icon-download" style="margin-left: 5px;"></i>
                    </el-tag>
                       <i v-if="file.url"
                      class="el-icon-delete"
                      style="margin-left: 5px; cursor: pointer; color: #f56c6c;"
                      @click="deleteFile(file)"
                    ></i>
                    <el-tag v-if="file.is_check">线下已准备</el-tag>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="线下已准备" width="100">
              <template slot-scope="props" v-if="requiredFileKeys.indexOf(props.row[0]) === -1">
                <el-tag v-if="getFileListByKey(props.row[0])[0] && getFileListByKey(props.row[0])[0].is_check">已确认</el-tag>
                <el-button
                  size="small" v-else
                  type="success"
                  :loading="checkFileKeys[props.row[0]]"
                  :disabled="checkFileKeys[props.row[0]] || !caseId"
                  @click="handleCheckFile(props.row[0])"
                >
                  线下已准备
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="上传" width="80">
              <template slot-scope="props">
                <el-upload
                  :http-request="(param) => handleUploadFile(param, props.row[0])"
                  action=""
                  :show-file-list="false"
                  multiple
                >
                  <el-button size="small" type="primary" :loading="uploadFileKeys[props.row[0]]" :disabled="uploadFileKeys[props.row[0]] || !caseId">上传</el-button>
                </el-upload>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
    </el-table>

    <br/>
<!--    <el-button size="small" type="primary" @click="goToSealFlow">前往盖章流程</el-button>-->
  </div>
</template>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/law_case/case_file_form.vue